const moment = require('moment-timezone');
moment.tz.setDefault('America/Chicago');


const convert=(date,format)=>{
    return moment(date).tz('America/Chicago').format(format);
}


module.exports={
    convert
}